import { HTMLAttributes } from 'react';
import styled from 'styled-components';

type TextStyleType =
  | 'sb36'
  | 'sb30'
  | 'sb26'
  | 'sb20'
  | 'sb18'
  | 'sb16'
  | 'sb14'
  | 'n18'
  | 'n16'
  | 'n14'
  | 'n13'
  | 'n12';

interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
  type?: TextStyleType;
  style?: React.CSSProperties; // React.CSSProperties 타입의 style 속성 추가
}

const TEXT_STYLES: { [key in TextStyleType]: any } = {
  sb36: {
    fontSize: '36px',
    fontWeight: 600,
  },
  sb30: {
    fontSize: '30px',
    fontWeight: 600,
  },
  sb26: {
    fontSize: '26px',
    fontWeight: 600,
  },
  sb20: {
    fontSize: '20px',
    fontWeight: 600,
  },
  sb18: {
    fontSize: '18px',
    fontWeight: 600,
  },
  sb16: {
    fontSize: '16px',
    fontWeight: 600,
  },
  sb14: {
    fontSize: '14px',
    fontWeight: 600,
  },
  n18: {
    fontSize: '18px',
    fontWeight: 'normal',
  },
  n16: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  n14: {
    fontSize: '14px',
    fontWeight: 'normal',
  },
  n13: {
    fontSize: '13px',
    fontWeight: 'normal',
  },
  n12: {
    fontSize: '12px',
    fontWeight: 'normal',
  },
};

const Text2 = ({ children, type, style, ...rest }: TextProps) => {
  return (
    <TextComponent
      style={{
        ...TEXT_STYLES[type || 'n14'],
        ...style,
      }}
      {...rest}
    >
      {children}
    </TextComponent>
  );
};

export default Text2;

const TextComponent = styled.p`
  font-family: 'Pretendard';
  white-space: pre-wrap;
`;
